














import Vue from 'vue'
import Call from '@/components/Call.vue'
import Hotline from '@/components/Hotline.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import { Loading, Alert, Carousel, CarouselItem, Pagination, Menu, Submenu, MenuItem, Dialog, Select, Option } from 'element-ui'
Vue.use(Loading)
Vue.use(Alert)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)

export default Vue.extend({
  components: { Header, Footer, Call, Hotline },
})
